import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "groupClose",
  "use": "groupClose-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"groupClose\">\n<path d=\"M12.9788 4.31226H8.10583L7.13525 3.05763C7.10628 3.01977 7.06286 2.99854 7.0176 3.00008H3.09642C2.50948 3.00641 2.03692 3.52581 2.0376 4.1639V11.8375C2.03757 12.475 2.50995 12.9937 3.09642 13H12.9788C13.5652 12.9937 14.0376 12.475 14.0376 11.8375V5.4748C14.0376 4.83722 13.5652 4.31859 12.9788 4.31226Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol